import { render } from "./CadastrarCategoriaPropaganda.vue?vue&type=template&id=6c902140&scoped=true"
import script from "./CadastrarCategoriaPropaganda.vue?vue&type=script&lang=js"
export * from "./CadastrarCategoriaPropaganda.vue?vue&type=script&lang=js"

import "./CadastrarCategoriaPropaganda.vue?vue&type=style&index=0&id=6c902140&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c902140"]])

export default __exports__